<template>
    <div>
        <v-row>
            <v-col>
                <v-card class="pa-4 mb-4" :loading="isBusy">
                    <v-card-title>
                        <label v-html="byDayTitle"/>
                        <v-spacer></v-spacer>
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn color="primary" dark v-on="on">{{ lastSearch }}</v-btn>
                            </template>
                            <v-list>
                                <v-list-item key="this" @click="thisSelected">
                                    <v-list-item-title>{{ thisMonth }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item key="last" @click="lastSelected">
                                    <v-list-item-title>{{ lastMonth }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item key="previous" @click="previousSelected">
                                    <v-list-item-title>{{ previousMonth }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-card-title>
                    <div>
                        <apexchart ref="byDayChart" type="bar" :options="options" :series="combinedChartSeries"></apexchart>
                    </div>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card class="pa-4 mb-4" :loading="isBusy" height="100%">
                    <v-card-title>
                        <label v-html="userTitle"/>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-row>
                        <v-col>
                            <v-card elevation="0">
                                <apexchart ref="usersChartCount" :series="usersCountSeries" :options="donutOptions"></apexchart>
                            </v-card>
                            <v-card-actions>
                                    <h4 class="grey--text lighten-1">Count</h4>
                            </v-card-actions>
                        </v-col>
                        <v-col>
                            <v-card elevation="0">
                                <apexchart ref="usersChartDuration" :series="usersDurationSeries" :options="donutOptions"></apexchart>
                            </v-card>
                            <v-card-actions>
                                    <h4>Duration</h4>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-layout child-flex>
                            <v-data-table :headers="tableUsers.headers" :items="tableUsers.users" :loading="isBusy" :loading-text="tableUsers.loadingText" default-sort="duration:desc" fill-height></v-data-table>
                        </v-layout>
                    </v-row>
                </v-card>
            </v-col>
            <v-col>
                <v-card class="pa-4 mb-4" :loading="isBusy" height="100%">
                    <v-card-title>
                        <label v-html="clientTitle"/>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-row>
                        <v-col>
                            <v-card elevation="0">
                                <apexchart ref="usersChartCount" :series="clientsCountSeries" :options="donutOptions"></apexchart>
                            </v-card>
                            <v-card-actions>
                                    <h4>Count</h4>
                            </v-card-actions>
                        </v-col>
                        <v-col>
                            <v-card elevation="0">
                                <apexchart ref="usersChartDuration" :series="clientsDurationSeries" :options="donutOptions"></apexchart>
                            </v-card>
                            <v-card-actions>
                                    <h4>Duration</h4>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-layout child-flex>
                            <v-data-table :headers="tableClients.headers" :items="tableClients.clients" :loading="isBusy" :loading-text="tableClients.loadingText" default-sort="duration:desc" fill-height></v-data-table>
                        </v-layout>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import moment from "moment";


export default {
    name: "Usage",
    data() {
        return {
            title: "Usage",
            byDayTitle: "Count And Duration by Day",
            userTitle: "User Totals",
            clientTitle: "Client Totals",
            isBusy: false,
            fromDate: moment(),
            toDate: moment(),
            lastSearch: "This Month",
            thisMonth: "This",
            lastMonth: "Last",
            previousMonth: "Previous",
            options: {
                chart: {
                    id: "byday",
                    stacked: false,
                    toolbar: {
                        show: false,
                    },
                },
                xaxis: {
                    categories: [""],
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter(y) {
                            if (typeof y !== "undefined") {
                                return `${y.toFixed(0)} points`;
                            }
                            return y;
                        },
                    },
                },
            },
            combinedChartSeries: [{
                name: "Count",
                type: "column",
                data: [0],
            }, {
                name: "Duration",
                type: "area",
                data: [0],
            }],
            donutOptions: {
                chart: {
                    type: "donut",
                },
                legend: {
                    show: false,
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: "80%",
                        },
                    },
                },
            },
            usersLabels: [
            ],
            usersCountSeries: [
            ],
            usersDurationSeries: [
            ],
            clientsLabels: [
            ],
            clientsCountSeries: [
            ],
            clientsDurationSeries: [
            ],
            tableUsers: {
                loadingText: "Loading Users...",
                headers: [
                    { text: "User", value: "user", sortable: false },
                    { text: "Clients", value: "clientCount" },
                    { text: "Duration", value: "duration" },
                ],
                users: [],
            },
            tableClients: {
                loadingText: "Loading Clients...",
                headers: [
                    { text: "Client", value: "client", sortable: false },
                    { text: "Users", value: "userCount" },
                    { text: "Duration", value: "duration" },
                ],
                clients: [],
            },
        };
    },
    mounted() {
        this.thisSelected();
    },
    methods: {
        setLastSearch() {
            this.lastSearch = moment(this.fromDate).format("MMM YYYY");
        },
        thisSelected() {
            const today = new Date();
            this.fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
            this.toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
            this.loadData();
            this.setLastSearch();
        },
        lastSelected() {
            const today = new Date();
            this.fromDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            this.toDate = new Date(today.getFullYear(), today.getMonth(), 0);
            this.loadData();
            this.setLastSearch();
        },
        previousSelected() {
            const today = new Date();
            this.fromDate = new Date(today.getFullYear(), today.getMonth() - 2, 1);
            this.toDate = new Date(today.getFullYear(), today.getMonth() - 1, 0);
            this.loadData();
            this.setLastSearch();
        },
        loadData() {
            this.isBusy = true;
            this.$refs.byDayChart.updateOptions({
                chart: {
                    height: 200,
                },
                xaxis: {
                    categories: [""],
                },
            });

            this.$refs.byDayChart.updateSeries([{
                data: [0],
            }]);

            this.usersSeries = [];
            this.clientsSeries = [];

            const query = `${this.$ls.get("FirmGUID")}/${moment(this.fromDate).format("YYYY-MM-DD")}/${moment(this.toDate).format("YYYY-MM-DD")}`;

            this.$http
                .get(`/api/stats/combined/${query}`)
                .then((response) => {
                    this.$refs.byDayChart.updateOptions({
                        xaxis: {
                            categories: response.data.byDayLabels,
                        },
                    });

                    this.$refs.byDayChart.updateSeries([{
                        data: response.data.byDayCount,
                    }]);

                    this.$refs.byDayChart.appendSeries({
                        name: "Duration",
                        type: "area",
                        data: response.data.byDayDuration,
                    });

                    this.tableUsers.users = response.data.byUser;
                    this.tableClients.clients = response.data.byClient;

                    for (let step = 0; step < this.tableUsers.users.length; step += 1) {
                        this.usersLabels.push(this.tableUsers.users[step].user);
                        this.usersCountSeries.push(this.tableUsers.users[step].clientCount);
                        this.usersDurationSeries.push(this.tableUsers.users[step].duration);
                    }

                    for (let step = 0; step < this.tableClients.clients.length; step += 1) {
                        this.clientsLabels.push(this.tableClients.clients[step].client);
                        this.clientsCountSeries.push(this.tableClients.clients[step].userCount);
                        this.clientsDurationSeries.push(this.tableClients.clients[step].duration);
                    }

                    this.isBusy = false;
                })
                .catch((err) => {
                    this.loginError = true;
                    this.isBusy = false;
                    this.$alert({ type: "error", title: "Search Failed", message: err.response.data.exceptionMessage });
                });
        },
    },
};
</script>
